export const DESIGN_TOKENS = Object.freeze({
  color: {
    canvas: '#EEF0EB',
    surface: '#FBF8F0',
    surfaceStrong: '#FFFDF7',
    ink: '#202732',
    muted: '#656D78',
    line: 'rgba(32, 39, 50, 0.12)',
    lineStrong: 'rgba(32, 39, 50, 0.2)',
    accent: '#315548',
    accentSoft: '#DCE6DF',
    info: '#4F6D8F',
    infoSoft: '#DDE5EC',
    success: '#356B55',
    successSoft: '#DDEADF',
    warning: '#92633F',
    warningSoft: '#F0E1D2',
    danger: '#A34C4C',
    dangerSoft: '#F3DEDC',
    security: '#5C547E',
    securitySoft: '#E5E1F0',
  },
  radius: {
    control: '0.875rem',
    card: '1.25rem',
    panel: '1.75rem',
    dialog: '2rem',
    pill: '999px',
  },
  shadow: {
    control: '0 10px 28px rgba(32, 39, 50, 0.08)',
    card: '0 18px 48px rgba(32, 39, 50, 0.10)',
    panel: '0 28px 80px rgba(32, 39, 50, 0.12)',
    dialog: '0 36px 120px rgba(15, 23, 42, 0.22)',
  },
  duration: {
    feedback: 180,
    control: 240,
    component: 360,
    route: 520,
  },
  ease: {
    premium: [0.22, 1, 0.36, 1],
    standard: [0.2, 0, 0, 1],
  },
});

export const FEEDBACK_TONES = Object.freeze({
  neutral: {
    label: 'Update',
    icon: 'info',
  },
  info: {
    label: 'Information',
    icon: 'info',
  },
  success: {
    label: 'Completed',
    icon: 'success',
  },
  warning: {
    label: 'Needs attention',
    icon: 'warning',
  },
  danger: {
    label: 'Could not complete',
    icon: 'danger',
  },
  security: {
    label: 'Security',
    icon: 'security',
  },
});
